import { render, staticRenderFns } from "./sal-components.vue?vue&type=template&id=05e690f0"
import script from "./sal-components.vue?vue&type=script&lang=js"
export * from "./sal-components.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports